import { apiRQ } from '../../api';
import { useMutation } from 'react-query';
import { IGenericResponse } from '../../../interfaces/shared.interface';
import { getHttpMethod } from '../../helpers';

const updateCreateClient = async (variables: any): Promise<IGenericResponse> => {
  const resp = await apiRQ[getHttpMethod(variables?.id)]<IGenericResponse>('/admin/clients/', { data: variables });

  return resp.data;
};

export const useUpdateCreateClient = () => {
  return useMutation<IGenericResponse, Error>(updateCreateClient);
};

const deleteClient = async (data: any): Promise<IGenericResponse> => {
  const resp = await apiRQ.delete<IGenericResponse>('/admin/clients/', { data });

  return resp.data;
};

export const useDeleteClient = () => {
  return useMutation<IGenericResponse, Error>(deleteClient);
};
